import React from "react";

function Card3() {
  return (
    <div className="card-div3">
      <div className="emoji">🐕‍🦺</div>
      <div className="emojiName">Service Dog</div>
      <div className="emoji-description">
        A service animal displayed with a safety vest and lead. Differs from the
        guide dog as this animal is intended for detection of seizures or other
        “hidden disabilities”, according to the proposal from Apple.
      </div>
    </div>
  );
}

export default Card3;
